<div class="kt-subheader__toolbar">
    <div class="kt-subheader__wrapper">
        <a href="javascript:;" class="btn kt-subheader__btn-secondary" (click)="onUserClone()">
            Kullanıcı Kopyala
        </a>

        <!-- <div ngbDropdown [placement]="'bottom-right'" class="dropdown dropdown-inline">
            <a ngbDropdownToggle href="javascript:;" class="btn btn-danger kt-subheader__btn-options">
                Products
            </a>
            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
                <a class="dropdown-item" href="javascript:;"><i class="la la-plus"></i> New Product</a>
                <a class="dropdown-item" href="javascript:;"><i class="la la-user"></i> New Order</a>
                <a class="dropdown-item" href="javascript:;"><i class="la la-cloud-download"></i> New Download</a>
                <div class="dropdown-divider"></div>
                <a class="dropdown-item" href="javascript:;"><i class="la la-cog"></i> Settings</a>
            </div>
        </div> -->
    </div>
</div>


<!-- Klonlacak kullanici icin "As Soyad, UserName ve Passowrd" bilgilerinin alindi modal  -->
<ng-template #modalTemplateNewUserInfo>

    <div class="kt-portlet">
        <div class="kt-portlet__head kt-portlet__head__custom">
            <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">{{user.getValue().fullName}} - ({{user.getValue().customerName}})</h3>
               
            </div>
          
        </div>
     
        <form class="kt-form">
            <div class="kt-portlet__body">
                <p>Kullanıcının tüm yetkileri kopyalanarak yeni bir kullanıcı oluşturulacak.</p>
                <div class="form-group kt-form__group row">
                    <div class="col-md-4 kt-margin-bottom-10-mobile">

                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput placeholder="Ad Soyad" type="text" />
                            <mat-error>
                                Name is
                                <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
    
                    <div class="col-md-4 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput placeholder="Kullanıcı Adı" type="text" />
                            <mat-error>
                                UserName is
                                <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
    
                    <div class="col-md-4 kt-margin-bottom-10-mobile">
                        <mat-form-field class="mat-form-field-fluid">
                            <input matInput placeholder="Şifre" type="password" />
                            <mat-error>
                                Password is
                                <strong>required</strong>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit">
                <div class="kt-form__actions kt-form__actions--solid">
                    <div class="row text-right">
                        <div class="col-lg-12">
                            <button type="button" mat-raised-button [mat-dialog-close]="'Yes'" cdkFocusInitial
                                matTooltip="Cancel changes">
                                Cancel
                            </button>&nbsp;
                            <button type="button" mat-raised-button color="primary"
                            class="btn btn-primary kt-login__btn-primary"
                            [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': modalSaving}"
                            (click)="onUserClone()" matTooltip="Save changes112">
                            {{modalSaveButtonTitle}}
                        </button>
                            <!-- <button type="button" mat-raised-button color="primary"
                                class="btn btn-primary btn-elevate kt-login__btn-primary"
                                [ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': modalSaving}"
                                (click)="onUserClone()" matTooltip="Save changes112">
                                {{modalSaveButtonTitle}}
                            </button> -->
                        </div>
                    </div>
                </div>
            </div>

        </form>
    </div>
</ng-template>